import { render, staticRenderFns } from "./LoginHome.vue?vue&type=template&id=3b6cee3c&scoped=true"
import script from "./LoginHome.vue?vue&type=script&lang=js"
export * from "./LoginHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6cee3c",
  null
  
)

export default component.exports